export async function Signup(targetUrl: string,
							 failUrl: string,
							 email: string,
							 age: number,
							 gender: string,
							 birthday: string) {

	let domainId: number;

	switch (age) {
		case 16:
			domainId = 1;
			break;
		case 18:
			domainId = 2;
			break;
		case 12:
		default:
			domainId = 0;
			break;
	}

	const response = await fetch(targetUrl, {
		method: 'POST',
		cache: 'no-cache',
		mode: 'cors',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({
			email: email,
			gender: gender,
			domainId: domainId,
			birthday: birthday
		})
	})

	const data = await response.json();

	if (data.success === true && typeof data.data !== null) {
		window.location.href = data.data;
	} else {
		window.location.href = failUrl;
	}
}

export function checkEmail(email: string): boolean {
	return email.match(/^.+@.+\..+$/) !== null;
}

export function isFilled(content: string): boolean {
	return content.trim().length !== 0;
}
